import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch, Collapse, AutoComplete
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined, MinusCircleOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import moment from 'moment'

import MultiAssocForm2 from "../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../components/permissions/PermissionAlert";
import ContactIcon from "../components/util-components/ContactIcon";
import ImageUploadField from "../components/custom-fields/ImageUpload";
import {getCountry, getDevise, getDeviseSymbol} from "../components/permissions/functions";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {connect} from "react-redux";
import ModalBasePaiement from "./ModalBasePaiement";

import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import CampagneAddonForm from '../components/CampagneAddonForm';

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalCerfaGroupe extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        step: 0,
        types:[],
        defaultData: {},
        baseData:{}
    };

    state = this.initstate

    async show(contact = null) {
        console.log("PAYEMENT GROUPE CERFA ",)

        this.modalBasePaiement.show(contact,(baseData)=>{
            this.getTypes(baseData,()=>{
                this.setState({visible: true, baseData: {...baseData}})
            })
        })
    }

    async getTypes(baseData,callback = null) {
        var res2 = await ApiService.get("/paiements/cerfa/types/", {contact: baseData?.contact})
        console.log(res2)
        this.setState({types: res2.items}, () => {
            if (callback) {
                callback()
            }
        })
    }


    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        if(this.state.loading){
            return false
        }
        this.setState({loading:true})



        let details=data.details || []
        details=details.map(d=>{
            const raison=d.raison || null
            const typeData=this.state.types.find(i=>i.value===raison)
            const type=typeData.type
            const typeId=typeData.value
            delete d.raison
            return {...d,type:type,typeId:typeId}
        })

        var config = {
            details:details,
            ...this.state.baseData,
            method: data.method,
            datetime: data.datetime.toDate(),
            cerfa: data.cerfa || false,
            commentaire: data.commentaire || null,
            extra: data.extra
        }


        var res = await ApiService.post("/paiements/cerfa/createGroup/", config)
        console.log(res)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.add"/>)
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: (<IntlMessage id="error.add"/>)
            })
        }
    }


    getFilteredTypes(types)
    {
        const assocInfo=this.props.org.cerfasInfos.find(i=>i.id===(this.state.baseData?.assoc || "MAIN"))

        types=types.filter(i=>{
            if(i?.data?.devise && i.data?.devise!==assocInfo?.devise){
                return false
            }
            return true
        })

        return types
    }

    render() {

        const baseData=this.state.baseData

        return (

            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}} title={t`Enregistrer un Groupe de Paiement`}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.add"]}>




                        <div style={{margin: "50px 50px"}}>
                            <Form
                                initialValues={{
                                    datetime: moment(new Date()),
                                }}
                                onFinish={(data) => this.onFinish(data)}
                            >

                                <Form.List name="details">
                                    {(fields, {add, remove}) => {

                                        return(
                                            <Fragment>

                                                {fields.map(({key, name, ...restField}) => (
                                                    <Card title={t`Renseigner le paiement`} extra={(
                                                        <MinusCircleOutlined color={"red"} onClick={() => remove(name)}/>)}>

                                                        <Form.Item
                                                            {...restField}
                                                            label={t`Nom du paiement`}
                                                            name={[name, 'name']}
                                                        >
                                                            <Input placeholder={t`Nom du paiement`}/>
                                                        </Form.Item>


                                                        <Form.Item
                                                            {...restField}
                                                            label={t`Raison du Paiement`}
                                                            name={[name, 'raison']}
                                                            //rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                        >
                                                            <Select showSearch filterOption={(input, option) => {
                                                                var text = option.props.children
                                                                if (Array.isArray(text)) {
                                                                    text = text.join("")
                                                                }
                                                                return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }} placeholder={t`Raison du Paiement`}>
                                                                {this.getFilteredTypes(this.state.types).map((item, index) => {
                                                                    return <Option key={index} value={item.value}>{item.label}</Option>
                                                                })}
                                                            </Select>
                                                        </Form.Item>

                                                        <Form.Item noStyle shouldUpdate>
                                                            {()=>{
                                                                const devise=this.props.org.cerfasInfos.find(i=>i.id===(baseData?.assoc || "MAIN"))?.devise || getDevise()
                                                                return(
                                                                    <Form.Item
                                                                        {...restField}
                                                                        label={t`Montant`}
                                                                        name={[name, 'montant']}
                                                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                                    >
                                                                        <InputNumber
                                                                            decimalSeparator={','} min={1}
                                                                            step={0.5}
                                                                            addonAfter={getDeviseSymbol(devise)}
                                                                        />
                                                                    </Form.Item>
                                                                )
                                                            }}
                                                        </Form.Item>



                                                        <Form.Item noStyle shouldUpdate>
                                                            {form => {
                                                                const raison=form.getFieldValue(["details",name,"raison"])
                                                                //console.log(raison)

                                                                let type=null
                                                                let typeId=null
                                                                let typeData=null

                                                                if(raison) {
                                                                    typeData=this.state.types.find(i=>i.value===raison)
                                                                    if(typeData){
                                                                        type=typeData.type
                                                                        typeId=typeData.value
                                                                    }
                                                                }

                                                                if(type === "CAMPAGNE")
                                                                {
                                                                    return(
                                                                        <CampagneAddonForm name={[name,"campagne"]} campagneId={typeId}/>
                                                                    )
                                                                }
                                                            }}

                                                        </Form.Item>




                                                    </Card>
                                                ))}

                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => add()} block
                                                            icon={<PlusOutlined/>}>
                                                        <Trans>Ajouter un Produit</Trans>
                                                    </Button>
                                                </Form.Item>
                                            </Fragment>
                                        )
                                    }}
                                </Form.List>



                                <Form.Item
                                    label={t`Moyen de Paiement`}
                                    name="method"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <Select placeholder={t`Moyen de Paiement`}>
                                        <Option value="CHEQUE">{t`Chèque`}</Option>
                                        <Option value="VIREMENT">{t`Virement Bancaire`}</Option>
                                        <Option value="PRELEVEMENT">{t`Prélèvement Bancaire`}</Option>
                                        <Option value="CASH">{t`Espèces`}</Option>
                                        <Option value="CB">{t`Carte Bancaire`}</Option>
                                        <Option value="NATURE">{t`En Nature`}</Option>
                                    </Select>
                                </Form.Item>


                                <Form.Item
                                    label={t`Date du paiement`}
                                    name="datetime"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <DatePicker showTime format="DD/MM/YYYY HH:mm"/>
                                </Form.Item>


                                <Form.Item
                                    label={t`Cerfa`}
                                    name="cerfa"
                                    valuePropName={"checked"}
                                >
                                    <Switch/>
                                </Form.Item>


                                <Form.Item
                                    label={t`Commentaire`}
                                    name="commentaire"
                                >
                                    <Input.TextArea/>
                                </Form.Item>

                                <Form.Item noStyle
                                           shouldUpdate={(prevValues, curValues) => prevValues.method !== curValues.method}>
                                    {({getFieldValue}) => {
                                        const method = getFieldValue("method")
                                        console.log(method)

                                        if (method === "CHEQUE") {
                                            return (
                                                <Fragment>
                                                    <Divider><Trans>Informations du Chèque</Trans></Divider>
                                                    <Form.Item
                                                        label={t`Numéro du Chèque`}
                                                        name={["extra", "chequeId"]}
                                                    >
                                                        <Input placeholder={t`Numéro du Chèque`}/>
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={t`Image du Chèque`}
                                                        name={["extra", "chequeImage"]}
                                                    >
                                                        <ImageUploadField/>
                                                    </Form.Item>
                                                </Fragment>
                                            )
                                        }
                                    }}
                                </Form.Item>

                                <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button type="primary" htmlType="submit" disabled={this.state.loading} loading={this.state.loading}>
                                        <Trans>Valider</Trans>
                                    </Button>
                                </Form.Item>

                            </Form>
                        </div>

                    </PermissionAlert>
                </Modal>

                <ModalBasePaiement title={t`Enregistrer un Groupe de Paiement`} onlyContact getRef={(ref)=>this.modalBasePaiement=ref}/>
            </Fragment>


        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalCerfaGroupe)
